import SidePanel from './SidePanel.vue';

export default SidePanel;
